import script from "./AdminManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminManage.vue?vue&type=script&setup=true&lang=js"

import "./AdminManage.vue?vue&type=style&index=0&id=5a0b160a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0b160a"]])

export default __exports__